import React, { useContext, useEffect, useRef, useState } from "react";
import {
  PlusOutlined,
  CloseCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  Popconfirm,
  Row,
  Select,
  Table,
  Typography,
} from "antd";

const { Title } = Typography;


const EditableTable = ({
  tableTitle,
  paymentTypeOptions,
  fundSourceOptions,
  columnsOne,
  columnTwo,
  columnTitle1,
  columnTitle2,
  feesOptions,
}) => {
  const [dataSource, setDataSource] = useState([
    {
      key: "0",
      paymentType: "Edward King 0",
      fundSource: "32",
    }
  ]);
  const [count, setCount] = useState(2);

  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };

  const defaultColumns = [
    {
      title: columnTitle1,
      dataIndex: "paymentType",
      width: "30%",
      render: () => (
        <Form.Item name={columnsOne}>
          <Select
            style={{ width: "30vh" }}
            placeholder={"Please select a value"}
            options={feesOptions}
          />
        </Form.Item>
      ),
    },
    {
      title: columnTitle2,
      dataIndex: "fundSource",
      render: () => (
        <Form.Item name={columnTwo}>
          <Select
            style={{ width: "30vh" }}
            placeholder={"Please select a value"}
            options={fundSourceOptions}
          />
        </Form.Item>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <CloseOutlined
              style={{
                color: "#92428B",
                fontSize: "15px",
                fontWeight: "bolder",
              }}
            />
          </Popconfirm>
        ) : null,
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      paymentType: `Edward King ${count}`,
      fundSource: "32",
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
  });

  return (
    <div>
      <Row justify={"space-between"} align={"middle"}>
        <Title
          level={5}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          {tableTitle}
        </Title>
        <Button
          onClick={handleAdd}
          type="primary"
          icon={<PlusOutlined />}
          style={{ backgroundColor: "#92428B", color: "white", width: "15vh" }}
        >
          {" "}
          Add
        </Button>
      </Row>
      <Table
        // components={components}
        rowClassName={() => "editable-row"}
        // bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
    </div>
  );
};
export default EditableTable;
